import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import DownloadApp from "./components/DownloadApp/index"
import reportWebVitals from "./reportWebVitals"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"

ReactDOM.render(
  <React.StrictMode>
    {/* <App /> */}
    <Router>
      <Routes>
        <Route exact path="/" element={<App />}></Route>
        <Route exact path="/document-upload/" element={<App />}></Route>
        <Route path="/app/*" element={<DownloadApp />}></Route>
      </Routes>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
